// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"H9-z"};